<template>
  <BreadCrumb PageTitle="Modifier une dépense" />
  <EditSpent :spentId="spentId" />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import EditSpent from "../../components/Spents/EditSpent.vue";
import { useRoute } from "vue-router";
export default defineComponent({
  name: "EditSpentPage",
  components: {
    BreadCrumb,
    EditSpent,
  },

  setup: () => {
    const route = useRoute();
    let spentId = route.params.id;  // <-- get the id
    if (Array.isArray(spentId)) {
      spentId = spentId[0] ?? "";
    }

    return { spentId };
  }
});
</script>
